<template>
<div class="form-submission-card">
    <submission-title
        :form_name="form_submission.toolbox_talk_entry.toolbox_talk.name"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle
        :form_status="form_submission.form_status"
        @open-signature="openSignature(true)"
    />

    <div class="form-submission-card-content">
        <img
            class="img-fluid"
            v-if="form_submission.toolbox_talk_entry.toolbox_talk.photo_url"
            :src="form_submission.toolbox_talk_entry.toolbox_talk.photo_url"
        />

        <response-text
            question="Description"
            :answer="form_submission.toolbox_talk_entry.toolbox_talk.description"
        />

        <list-of-operatives-signatures
            v-if="!profile_page"
            :data="form_submission.toolbox_talk_entry.signatures"
            :inline_signature="pdf_mode"
            :show_url="show_url"
            is_nested
        />
    </div>
</div>
</template>

<script>
import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures";
import SubmissionTitle from "./SubmissionTitle";
import SubmissionSubtitle from "./SubmissionSubtitle";
import ResponseText from "./responses/ResponseText";

export default {
    name: "ToolboxTalksSubmission",
    components: { ListOfOperativesSignatures, SubmissionTitle, SubmissionSubtitle, ResponseText, },
    props: {
        form_submission: Object,
        show_url: {
            type: String,
            default: '',
        },
        profile_page: Boolean,
        pdf_mode: {
            type: Boolean,
            default: false,
        },
    }
}
</script>
